import React from "react";
import { RightArrowIcon } from "staysure-component-library";

import ButtonWrapper from "@/app/shared-components/button-wrapper/button-wrapper";
import SupportDrawer from "@/app/shared-components/drawer/support-drawer";
import RichText from "@/components/atoms/rich-text/rich-text";

import { usePMIContext } from "../../../provider/private-medical-insurance.provider";
import PMIDrawer from "../drawer/drawer";

function PMIDescriptionBody() {
  const {
    cmsData,
    isDrawerOpen,
    selectedStateCmsData,
    setIsDrawerOpen,
    pmiDetails,
  } = usePMIContext();

  const isFilledState = pmiDetails.every((item) => item?.hasPMI !== undefined);

  const { isLoadMoreButton, isLoadMoreButtonText } =
    cmsData.personalMedicalQuestionArea[0];

  const isLoadMoreButtonFinal = isLoadMoreButton && !isFilledState;
  // const isLoadMoreButtonTextFinal =
  //   pmiExperimentIsLoadMoreButtonText ?? isLoadMoreButtonText;
  return (
    <>
      <SupportDrawer
        isOpen={isDrawerOpen}
        setOpen={(value) => setIsDrawerOpen(value)}
      >
        <PMIDrawer />
      </SupportDrawer>
      <div
        className={`w-full md:p-0 rounded-radius-lg md:border-none 
       `}
      >
        <p
          className={` md:text-xs leading-[24px] md:leading-[27px] text-center
            text-2xs md:mb-spacing-m  text-surface-neutral-option-2`}
        >
          <RichText
            className={` lg:text-xs leading-[24px] lg:leading-[27px] text-center
            text-2xs md:mb-spacing-m  text-surface-neutral-option-2`}
            richText={selectedStateCmsData.description}
          />
        </p>

        {isLoadMoreButtonFinal && (
          <div className="load-more-wrapper text-center">
            <ButtonWrapper
              label={isLoadMoreButtonText}
              hierarchy="tertiary"
              semanticColor="Dark Background"
              id="load-more-button"
              className="text-center font-semibold text-xs !leading-custom-size-xxl"
              isRightIcon
              rightIcon={<RightArrowIcon stroke="white" />}
              onClick={() => setIsDrawerOpen(true)}
            />
          </div>
        )}
      </div>
    </>
  );
}

export default PMIDescriptionBody;
